import React from "react";
//import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import classes from "./IntroBox.module.css";

//const useStyles = makeStyles(() => ({
//add style content here for use of style function
//}));

export default function IntroBox() {
  return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="md" className={classes.test}>
        <div className={classes.title}>
          <Typography variant={"h6"}>Prosjektbeskrivelse</Typography>
        </div>
        <div className={classes.text}>
          <Typography align="left">
            Det skal utvikles en app for forsvaret hvor målet er å forenkle
            oppslag av opptakskrav til forskjellige grener. <br />
            <br /> Oppdragsgiver ønsker at kandidater for førstegangstjeneste og
            soldater skal kunne kartlegge hvor de ligger i forhold til kravene
            som stilles til gitte øvelser.
          </Typography>
        </div>
      </Container>
    </React.Fragment>
  );
}
